export const calculeTotalIPI = (array: any) => {
  if (!array) return []
  return array.reduce((acc: any, cur: any) => {
    return acc + (cur.ipiPercent / 100) * cur.quantity * cur.salePrice
  }, 0)
}
